import React from 'react';

function _getBorderStyle(animal) {
    if (animal === 'salmon') {
        return 'border-orange-300';
    } else if (animal === 'octopus') {
        return 'border-orange-300';
    } else if (animal === 'dolphin') {
        return 'border-blue-300';
    } else {
        return 'border-green-500';
    }
}

function _getBackgroundStyle(animal) {
    if (animal === 'salmon') {
        return 'bg-orange-50';
    } else if (animal === 'octopus') {
        return 'bg-orange-50';
    } else if (animal === 'dolphin') {
        return 'bg-blue-50';
    } else {
        return 'bg-emerald-50';
    }
}

/**
 * AnimalCard component that displays a themed container for quiz content.
 *
 * @param {Object} props - Component props
 * @param {string} props.animal - The animal name used to select styles
 * @param {React.ReactNode} props.children - Content to display inside the card
 * @param {string} [props.className] - Additional CSS classes for the container
 * @returns {JSX.Element} The AnimalCard component
 */
const AnimalCard = ({ animal, children, className = "" }) => {
  return (
    <div
      className={`w-full rounded-xl p-4 mt-4 ${className} border-2 ${_getBorderStyle(animal)} ${_getBackgroundStyle(animal)}`}
    >
      <div className="mx-2">
        {children}
      </div>
    </div>
  );
};

export default AnimalCard; 